import { ChevronLeft, DeleteIcon } from "lucide-react";
import { useEffect, useState } from "react";
import AddressModal from "../../components/Modal/AddAddressModal";
import { authFetch } from "../../../api";
import OrderSummary from "./SAP_OrderSummary";
import GlobalDeleteModal from "../../components/Modal/GlobalDeleteModal";
import ConfimationPopup from "../../../STMPages/components/customPopup/ConfimationPopup";
import EditAddressModal from "../../components/Modal/EditAddressModal";
import { useLocation } from "react-router-dom";
import AnimatedSnackbar from "../../../STMPages/components/snackbars/AnimatedSnackbar";
import {
  handleFetchOrderApi,
  handleVerifyPayment,
} from "../../../STMPages/pages/testPrepDashboard/Api/DashboardApi";
import ErrorPopupScreen from "../../../STMPages/components/customPopup/ErrorPopupScreen";
import SussceeffulyMessageScreen from "../../../STMPages/components/customPopup/SussceeffulyMessageScreen";
import DoneIcon from "@mui/icons-material/Done";
import { createSAPEnrollEnquiry } from "../../api/checkoutapi";
import { Backdrop, Grid } from "@mui/material";
import Loader from "../../components/Loader/Loader";

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

const SAP_Checkout = () => {
  const userId = localStorage.getItem("userId");
  const [modal, setModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const location = useLocation();
  const packageData = location.state;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [paymentProceessLoading, setPaymentProcessLoading] = useState(false);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonTitle, setButtonTitle] = useState("Okay");

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  useEffect(() => {
    const defaultAddress = addresses.find((a) => a.is_default);
    if (defaultAddress) {
      setSelectedAddressId(defaultAddress.id);
    }
  }, [addresses]);

  const handleSelect = (address) => {
    setSelectedAddressId(address.id);
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const fetchAddresses = async () => {
    try {
      const response = await authFetch("user-address/fetch-address", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await response.json();
      setAddresses(data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleEdit = (address) => {
    setSelectedAddress(address);
    setOpenEditModal(true);
  };

  const handleDelete = async (address) => {
    try {
      const response = await authFetch("user-address/delete-address", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: address.id, user_id: userId }),
      });
      const data = await response.json();
      if (data.success) {
        setAddresses((prev) => prev.filter((a) => a.id !== address.id));
      }
      setOpenDeleteModal(false);
      setSelectedAddress(null);
    } catch (err) {
      console.log(err);
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    setPaymentProcessLoading(true);

    // Utility function to handle errors
    const showError = (message, button = "Got It") => {
      setErrorMessage(message);
      setButtonTitle(button);
      handleOpenErrorPopup();
      setPaymentProcessLoading(false);
    };

    // Utility function to handle success
    const showSuccess = (message) => {
      setErrorMessage(message);
      handleOpenSuccessPopup();
      setPaymentProcessLoading(false);
    };

    try {
      if (!selectedBillingAddress) {
        showError("Please choose an address before continuing");
        return;
      }

      const hasInstallments =
        Array.isArray(packageData?.installments) &&
        packageData.installments.length > 0;

      const activeInstallment = hasInstallments
        ? packageData?.installments.find((inst) => inst.active)
        : null;

      const amountToPay = activeInstallment
        ? Object.values(activeInstallment).find((v) => typeof v === "number")
        : hasInstallments
          ? packageData?.installments[0]?.installment_1_amount ||
            packageData?.original_price
          : packageData?.original_price;

      const pendingAmount = activeInstallment
        ? packageData?.pending_amount
        : hasInstallments
          ? packageData?.original_price -
            packageData.installments[0]?.installment_1_amount
          : null;

      const today = new Date().toISOString().split("T")[0];

      //create enquiry on CRM
      const enquiryPayload = {
        package_id: packageData?.id,
        user_id: parseInt(userId),
      };

      const enquiryRes = await createSAPEnrollEnquiry(enquiryPayload);
      if (enquiryRes.status !== 201)
        throw new Error("Failed to create enquiry");

      const enquiryData = enquiryRes.data;

      const orderDetails = {
        enquiry_id: enquiryData?.id,
        package_id: packageData?.id,
        service_id: enquiryData?.service_id,
        sub_service_id: enquiryData?.sub_service_id,
        scholars_program_id: packageData?.scholars_program_id,
        enrollment_date: today,
        is_past_enroll_date: false,
        payment_mode_id: 2,
        user_id: parseInt(userId),
        package_amount: packageData?.original_price,
        amount_to_be_paid: amountToPay,
        amount_paid: amountToPay,
        is_manual_discount: false,
        payable_installments: hasInstallments
          ? packageData.installments.length
          : 1,
        is_partial_payment: hasInstallments ? true : false,
        pending_amount: hasInstallments ? pendingAmount : null,
        currency: packageData?.currency,
        billing_address_id: selectedBillingAddress
          ? selectedBillingAddress
          : null,
        is_new_payment: packageData?.is_new_payment || true,
        installment_number: packageData?.installment_number,
      };

      const orderRes = await handleFetchOrderApi(orderDetails);
      if (!orderRes) {
        showError("No response from server");
        throw new Error("No response from server");
      }

      if (!orderRes || (orderRes.status !== 200 && orderRes.status !== 201)) {
        showError(orderRes?.message || "Internal Server Error");
        return;
      }

      const orderData = orderRes?.data?.order_res;

      const scriptLoaded = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js",
      );
      if (!scriptLoaded) {
        showError("Razorpay SDK failed to load. Are you online?");
        return;
      }

      const razorpayOptions = {
        key: RAZORPAY_KEY_ID,
        amount: orderData?.amount,
        currency: orderData?.currency,
        name: "Scholastic Test Masters",
        description: "Secure payment for your selected package",
        image: "/stm-logo-dark 1 (2).png",
        order_id: orderData?.id,

        handler: async (rzpResponse) => {
          try {
            const verifyRes = await handleVerifyPayment(rzpResponse);
            if (verifyRes.status === 200) {
              showSuccess(
                "A message and email will be sent once the payment has been confirmed by our team.",
              );
            } else {
              showError(
                "There was a technical issue while confirming your payment. Please avoid retrying.",
              );
            }
          } catch {
            showError(
              "There was a technical issue while confirming your payment. Please avoid retrying.",
            );
          }
        },

        modal: {
          confirm_close: true,
          ondismiss: (reason) => {
            const messages = {
              undefined: "You have cancelled the payment.",
              timeout: "Your payment session timed out. Please try again.",
              payment_failed:
                "Your payment failed. Please try again or use a different payment method.",
              payment_cancelled: "The payment was cancelled. Please try again.",
              payment_declined:
                "Your payment was declined. Please check with your bank or try another method.",
              payment_timed_out: "Your payment timed out. Please try again.",
              payment_collect_request_expired:
                "The payment request expired. Please initiate a new payment.",
            };

            const message =
              messages[reason] ||
              "An unknown error occurred. Please try again.";
            showError(message, "Retry Payment");
          },
        },

        timeout: 900,
        theme: { color: "#572575" },
      };

      const razorpay = new window.Razorpay(razorpayOptions);

      razorpay.on("payment.failed", (err) => {
        console.error("Razorpay payment.failed:", err);
        showError(
          err.error?.description ||
            "Payment failed. Please try again or use a different payment method.",
          "Retry Payment",
        );
      });

      document.body.style.overflow = "auto";

      try {
        razorpay.open();
      } catch (error) {
        console.error("Razorpay Checkout error:", error);
        showError(error.description, "Retry Payment");
      }
    } catch (error) {
      console.error("handlePayment error:", error);
      showError("Internal Server Error");
    } finally {
      document.body.style.overflow = "auto";
    }
  };

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <div className="min-h-screen font-siromi">
      {paymentProceessLoading && (
        <Grid item xs={12}>
          <Backdrop open={paymentProceessLoading} style={{ zIndex: 9999 }}>
            <Loader text="Submitting your payment, please wait..." />
          </Backdrop>
        </Grid>
      )}
      <AnimatedSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
      {openDeleteModal && selectedAddress && (
        <ConfimationPopup
          handleClose={() => {
            setOpenDeleteModal(false);
            setSelectedAddress(null);
          }}
          open={openDeleteModal}
          component={
            <GlobalDeleteModal
              text="Delete Address?"
              subText="Are you sure you want to delete this address? Once deleted, it cannot be recovered."
              buttonTitle="Delete"
              // startIcon={<DeleteIcon />}
              onClose={() => {
                setOpenDeleteModal(false);
                setSelectedAddress(null);
              }}
              onConfirm={() => {
                handleDelete(selectedAddress);
                showSnackbar("Address deleted successfully", "success");
              }}
            />
          }
        />
      )}
      {/* Back button + Title */}
      <a href="/sap/pricing-plan">
        <div className="flex items-center space-x-2 text-[#000000] mb-4">
          <span className="cursor-pointer text-xl">
            <ChevronLeft />
          </span>
          <h1 className="font-siromi text-[32px] leading-[100%] text-[#000000] align-middle">
            Checkout
          </h1>
        </div>
      </a>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Billing Address Section */}
        <div className="lg:col-span-2">
          <div className="bg-white shadow rounded-xl p-6">
            <div className="flex items-center justify-between mb-4 p-2">
              <h2 className="text-[24px] font-siromi text-[#572575] leading-[100%] align-middle">
                Billing Address
              </h2>

              <button
                onClick={() => setModal(true)}
                className="flex items-center gap-2 font-altisunisa font-bold text-[14px] leading-[100%] align-middle text-white bg-[#9D0385] px-4 py-3 rounded-md hover:bg-[#9D0385]"
              >
                <img
                  className="h-3 w-auto"
                  src="/SAPImages/checkout/plus.svg"
                  alt="plus"
                />
                Add New
              </button>
              {/* Add New Address Modal */}
              {modal && (
                <AddressModal
                  open={modal}
                  onClose={() => setModal(false)}
                  onSave={() => {
                    fetchAddresses();
                    showSnackbar("Address added successfully", "success");
                    setModal(false);
                  }}
                />
              )}
            </div>

            <div className="space-y-6">
              {addresses
                .slice()
                .sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0))
                .map((address, index) => {
                  const isSelected = selectedBillingAddress === address.id;

                  return (
                    <div
                      key={address.id}
                      //onClick={() => handleSelect(address)}
                      onClick={() => setSelectedBillingAddress(address.id)}
                      className={`border rounded-lg p-4 relative cursor-pointer transition-all duration-200 ${
                        isSelected
                          ? "border-[#572575] bg-[#FBF4FF]"
                          : "border-gray-200 bg-white hover:border-[#d7b8e6]"
                      }`}
                    >
                      <div className="flex items-center justify-between mb-3">
                        {/*  Label  */}
                        <span
                          className={`font-siromi text-[18px] leading-[100%] align-middle ${
                            address.is_default
                              ? "text-[#572575] "
                              : "text-gray-700 "
                          }`}
                        >
                          {address.is_default
                            ? "Default Address"
                            : `Address ${index + 1}`}
                        </span>

                        {/*  Action Icons */}
                        <div
                          className="absolute top-2 right-2 flex gap-2"
                          onClick={(e) => e.stopPropagation()} // Prevent selecting when clicking icons
                        >
                          <img
                            src="/SAPImages/checkout/edit.svg"
                            alt="edit"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenEditModal(true);
                              handleEdit(address);
                            }}
                          />

                          {openEditModal && selectedAddress && (
                            <EditAddressModal
                              open={openEditModal}
                              onClose={() => setOpenEditModal(false)}
                              onSave={(updatedAddress) => {
                                fetchAddresses();
                                showSnackbar(
                                  "Address updated successfully",
                                  "success",
                                );
                                setOpenEditModal(false);
                              }}
                              address={selectedAddress}
                            />
                          )}

                          <img
                            src="/SAPImages/checkout/delete.svg"
                            alt="delete"
                            title={
                              address.is_default
                                ? "You cannot delete your default address. Please set another address as default first."
                                : "Delete address"
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (address.is_default) {
                                showSnackbar(
                                  "You cannot delete your default address. Please set another address as default before deleting this one.",
                                  "warning",
                                );
                                return;
                              }

                              setSelectedAddress(address);
                              setOpenDeleteModal(true);
                            }}
                            className={`${
                              address.is_default
                                ? "opacity-40 cursor-not-allowed"
                                : "hover:opacity-80 cursor-pointer"
                            }`}
                          />
                        </div>
                      </div>

                      {/* 📍 Address Details */}
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-1 text-sm text-gray-700 font-altisunisa">
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            Name:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.name || "-"}
                          </b>
                        </p>
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            Country:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.country?.country_name || "-"}
                          </b>
                        </p>
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            State:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.state?.state_name || "-"}
                          </b>
                        </p>
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            City:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.city?.city_name || "-"}
                          </b>
                        </p>
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            Zip Code:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.zip_code || "-"}
                          </b>
                        </p>
                        <p>
                          <span className="text-[#555555] font-altis text-[14px] font-normal">
                            Street Address:
                          </span>{" "}
                          <b className="text-black font-altis text-[14px] font-normal">
                            {address.address || "-"}
                          </b>
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {/* Order Summary Section */}
        <OrderSummary packageData={packageData} onSubmit={handlePayment} />
      </div>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}
        navigateLink="/sap/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />

      <SussceeffulyMessageScreen
        text="Payment successful!"
        subText={errorMessage}
        buttonTitle="Thanks, Got it"
        startIcon={<DoneIcon />}
        navigateLink="/sap/timeline"
        currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />
    </div>
  );
};

export default SAP_Checkout;
